// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file calendar/event_response.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { PersonalizedUser } from '../user/user_model_pb';
import { file_user_user_model } from '../user/user_model_pb';
import type { CalendarError_Forbidden, CalendarError_Unauthorized } from './calendar_errors_pb';
import { file_calendar_calendar_errors } from './calendar_errors_pb';
import type { CalendarAccountStatus, CalendarEvent } from './event_model_pb';
import { file_calendar_event_model } from './event_model_pb';

/**
 * Describes the file calendar/event_response.proto.
 */
export const file_calendar_event_response: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_calendar_event_model, file_user_user_model, file_calendar_calendar_errors]
  );

/**
 * @generated from message com.gem.bff.contract.CreateCalendarEventResponse
 */
export type CreateCalendarEventResponse =
  Message<'com.gem.bff.contract.CreateCalendarEventResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.CreateCalendarEventResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.CreateCalendarEventSuccess success = 1;
           */
          value: CreateCalendarEventSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.CreateCalendarEventResponse.
 * Use `create(CreateCalendarEventResponseSchema)` to create a new message.
 */
export const CreateCalendarEventResponseSchema: GenMessage<CreateCalendarEventResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 0);

/**
 * @generated from message com.gem.bff.contract.CreateCalendarEventSuccess
 */
export type CreateCalendarEventSuccess =
  Message<'com.gem.bff.contract.CreateCalendarEventSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.CalendarEvent calendarEvent = 1;
     */
    calendarEvent?: CalendarEvent;
  };

/**
 * Describes the message com.gem.bff.contract.CreateCalendarEventSuccess.
 * Use `create(CreateCalendarEventSuccessSchema)` to create a new message.
 */
export const CreateCalendarEventSuccessSchema: GenMessage<CreateCalendarEventSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 1);

/**
 * @generated from message com.gem.bff.contract.GetCalendarEventResponse
 */
export type GetCalendarEventResponse = Message<'com.gem.bff.contract.GetCalendarEventResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetCalendarEventResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCalendarEventSuccess success = 1;
         */
        value: GetCalendarEventSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
         */
        value: CalendarError_Unauthorized;
        case: 'unauthorized';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
         */
        value: CalendarError_Forbidden;
        case: 'forbidden';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetCalendarEventResponse.
 * Use `create(GetCalendarEventResponseSchema)` to create a new message.
 */
export const GetCalendarEventResponseSchema: GenMessage<GetCalendarEventResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 2);

/**
 * @generated from message com.gem.bff.contract.GetCalendarEventSuccess
 */
export type GetCalendarEventSuccess = Message<'com.gem.bff.contract.GetCalendarEventSuccess'> & {
  /**
   * @generated from field: com.gem.bff.contract.CalendarEvent event = 1;
   */
  event?: CalendarEvent;
};

/**
 * Describes the message com.gem.bff.contract.GetCalendarEventSuccess.
 * Use `create(GetCalendarEventSuccessSchema)` to create a new message.
 */
export const GetCalendarEventSuccessSchema: GenMessage<GetCalendarEventSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 3);

/**
 * @generated from message com.gem.bff.contract.UpdateCalendarEventResponse
 */
export type UpdateCalendarEventResponse =
  Message<'com.gem.bff.contract.UpdateCalendarEventResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdateCalendarEventResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.UpdateCalendarEventSuccess success = 1;
           */
          value: UpdateCalendarEventSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdateCalendarEventResponse.
 * Use `create(UpdateCalendarEventResponseSchema)` to create a new message.
 */
export const UpdateCalendarEventResponseSchema: GenMessage<UpdateCalendarEventResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 4);

/**
 * @generated from message com.gem.bff.contract.UpdateCalendarEventSuccess
 */
export type UpdateCalendarEventSuccess =
  Message<'com.gem.bff.contract.UpdateCalendarEventSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.CalendarEvent calendarEvent = 1;
     */
    calendarEvent: CalendarEvent[];
  };

/**
 * Describes the message com.gem.bff.contract.UpdateCalendarEventSuccess.
 * Use `create(UpdateCalendarEventSuccessSchema)` to create a new message.
 */
export const UpdateCalendarEventSuccessSchema: GenMessage<UpdateCalendarEventSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 5);

/**
 * @generated from message com.gem.bff.contract.DeleteCalendarEventResponse
 */
export type DeleteCalendarEventResponse =
  Message<'com.gem.bff.contract.DeleteCalendarEventResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.DeleteCalendarEventResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.DeleteCalendarEventSuccess success = 1;
           */
          value: DeleteCalendarEventSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.DeleteCalendarEventResponse.
 * Use `create(DeleteCalendarEventResponseSchema)` to create a new message.
 */
export const DeleteCalendarEventResponseSchema: GenMessage<DeleteCalendarEventResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 6);

/**
 * @generated from message com.gem.bff.contract.DeleteCalendarEventSuccess
 */
export type DeleteCalendarEventSuccess =
  Message<'com.gem.bff.contract.DeleteCalendarEventSuccess'> & {
    /**
     * @generated from field: string eventId = 1;
     */
    eventId: string;
  };

/**
 * Describes the message com.gem.bff.contract.DeleteCalendarEventSuccess.
 * Use `create(DeleteCalendarEventSuccessSchema)` to create a new message.
 */
export const DeleteCalendarEventSuccessSchema: GenMessage<DeleteCalendarEventSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 7);

/**
 * @generated from message com.gem.bff.contract.GetCalendarEventsResponse
 */
export type GetCalendarEventsResponse =
  Message<'com.gem.bff.contract.GetCalendarEventsResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetCalendarEventsResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetCalendarEventsSuccess success = 1;
           */
          value: GetCalendarEventsSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetCalendarEventsResponse.
 * Use `create(GetCalendarEventsResponseSchema)` to create a new message.
 */
export const GetCalendarEventsResponseSchema: GenMessage<GetCalendarEventsResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 8);

/**
 * @generated from message com.gem.bff.contract.GetCalendarEventsSuccess
 */
export type GetCalendarEventsSuccess = Message<'com.gem.bff.contract.GetCalendarEventsSuccess'> & {
  /**
   * @generated from field: repeated com.gem.bff.contract.CalendarEvent calendarEvents = 1;
   */
  calendarEvents: CalendarEvent[];
};

/**
 * Describes the message com.gem.bff.contract.GetCalendarEventsSuccess.
 * Use `create(GetCalendarEventsSuccessSchema)` to create a new message.
 */
export const GetCalendarEventsSuccessSchema: GenMessage<GetCalendarEventsSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 9);

/**
 * @generated from message com.gem.bff.contract.DeleteRecurrenceCalendarEventResponse
 */
export type DeleteRecurrenceCalendarEventResponse =
  Message<'com.gem.bff.contract.DeleteRecurrenceCalendarEventResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.DeleteRecurrenceCalendarEventResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.DeleteRecurrenceCalendarEventSuccess success = 1;
           */
          value: DeleteRecurrenceCalendarEventSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.DeleteRecurrenceCalendarEventResponse.
 * Use `create(DeleteRecurrenceCalendarEventResponseSchema)` to create a new message.
 */
export const DeleteRecurrenceCalendarEventResponseSchema: GenMessage<DeleteRecurrenceCalendarEventResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 10);

/**
 * @generated from message com.gem.bff.contract.DeleteRecurrenceCalendarEventSuccess
 */
export type DeleteRecurrenceCalendarEventSuccess =
  Message<'com.gem.bff.contract.DeleteRecurrenceCalendarEventSuccess'> & {
    /**
     * @generated from field: string eventId = 1;
     */
    eventId: string;
  };

/**
 * Describes the message com.gem.bff.contract.DeleteRecurrenceCalendarEventSuccess.
 * Use `create(DeleteRecurrenceCalendarEventSuccessSchema)` to create a new message.
 */
export const DeleteRecurrenceCalendarEventSuccessSchema: GenMessage<DeleteRecurrenceCalendarEventSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 11);

/**
 * @generated from message com.gem.bff.contract.SubscribeToCalendarPushResponse
 */
export type SubscribeToCalendarPushResponse =
  Message<'com.gem.bff.contract.SubscribeToCalendarPushResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SubscribeToCalendarPushResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SubscribeToPushSuccess success = 1;
           */
          value: SubscribeToPushSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SubscribeToCalendarPushResponse.
 * Use `create(SubscribeToCalendarPushResponseSchema)` to create a new message.
 */
export const SubscribeToCalendarPushResponseSchema: GenMessage<SubscribeToCalendarPushResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 12);

/**
 * @generated from message com.gem.bff.contract.SubscribeToPushSuccess
 */
export type SubscribeToPushSuccess = Message<'com.gem.bff.contract.SubscribeToPushSuccess'> & {};

/**
 * Describes the message com.gem.bff.contract.SubscribeToPushSuccess.
 * Use `create(SubscribeToPushSuccessSchema)` to create a new message.
 */
export const SubscribeToPushSuccessSchema: GenMessage<SubscribeToPushSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 13);

/**
 * @generated from message com.gem.bff.contract.UpdateRecurrenceCalendarEventResponse
 */
export type UpdateRecurrenceCalendarEventResponse =
  Message<'com.gem.bff.contract.UpdateRecurrenceCalendarEventResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdateRecurrenceCalendarEventResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.UpdateRecurrenceCalendarEventSuccess success = 1;
           */
          value: UpdateRecurrenceCalendarEventSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdateRecurrenceCalendarEventResponse.
 * Use `create(UpdateRecurrenceCalendarEventResponseSchema)` to create a new message.
 */
export const UpdateRecurrenceCalendarEventResponseSchema: GenMessage<UpdateRecurrenceCalendarEventResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 14);

/**
 * @generated from message com.gem.bff.contract.UpdateRecurrenceCalendarEventSuccess
 */
export type UpdateRecurrenceCalendarEventSuccess =
  Message<'com.gem.bff.contract.UpdateRecurrenceCalendarEventSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.CalendarEvent calendarEvent = 1;
     */
    calendarEvent: CalendarEvent[];
  };

/**
 * Describes the message com.gem.bff.contract.UpdateRecurrenceCalendarEventSuccess.
 * Use `create(UpdateRecurrenceCalendarEventSuccessSchema)` to create a new message.
 */
export const UpdateRecurrenceCalendarEventSuccessSchema: GenMessage<UpdateRecurrenceCalendarEventSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 15);

/**
 * @generated from message com.gem.bff.contract.SaveCalendarCredentialResponse
 */
export type SaveCalendarCredentialResponse =
  Message<'com.gem.bff.contract.SaveCalendarCredentialResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SaveCalendarCredentialResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SaveCalendarCredentialSuccess success = 1;
           */
          value: SaveCalendarCredentialSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SaveCalendarCredentialResponse.
 * Use `create(SaveCalendarCredentialResponseSchema)` to create a new message.
 */
export const SaveCalendarCredentialResponseSchema: GenMessage<SaveCalendarCredentialResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 16);

/**
 * @generated from message com.gem.bff.contract.SaveCalendarCredentialSuccess
 */
export type SaveCalendarCredentialSuccess =
  Message<'com.gem.bff.contract.SaveCalendarCredentialSuccess'> & {};

/**
 * Describes the message com.gem.bff.contract.SaveCalendarCredentialSuccess.
 * Use `create(SaveCalendarCredentialSuccessSchema)` to create a new message.
 */
export const SaveCalendarCredentialSuccessSchema: GenMessage<SaveCalendarCredentialSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 17);

/**
 * @generated from message com.gem.bff.contract.LogoutCalendarResponse
 */
export type LogoutCalendarResponse = Message<'com.gem.bff.contract.LogoutCalendarResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.LogoutCalendarResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.LogoutCalendarSuccess success = 1;
         */
        value: LogoutCalendarSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.LogoutCalendarResponse.
 * Use `create(LogoutCalendarResponseSchema)` to create a new message.
 */
export const LogoutCalendarResponseSchema: GenMessage<LogoutCalendarResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 18);

/**
 * @generated from message com.gem.bff.contract.LogoutCalendarSuccess
 */
export type LogoutCalendarSuccess = Message<'com.gem.bff.contract.LogoutCalendarSuccess'> & {};

/**
 * Describes the message com.gem.bff.contract.LogoutCalendarSuccess.
 * Use `create(LogoutCalendarSuccessSchema)` to create a new message.
 */
export const LogoutCalendarSuccessSchema: GenMessage<LogoutCalendarSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 19);

/**
 * @generated from message com.gem.bff.contract.CheckAuthorizationResponse
 */
export type CheckAuthorizationResponse =
  Message<'com.gem.bff.contract.CheckAuthorizationResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.CheckAuthorizationResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.CheckAuthorizationSuccess success = 1;
           */
          value: CheckAuthorizationSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.CheckAuthorizationResponse.
 * Use `create(CheckAuthorizationResponseSchema)` to create a new message.
 */
export const CheckAuthorizationResponseSchema: GenMessage<CheckAuthorizationResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 20);

/**
 * @generated from message com.gem.bff.contract.CheckAuthorizationSuccess
 */
export type CheckAuthorizationSuccess =
  Message<'com.gem.bff.contract.CheckAuthorizationSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.CalendarAccountStatus accounts = 1;
     */
    accounts: CalendarAccountStatus[];
  };

/**
 * Describes the message com.gem.bff.contract.CheckAuthorizationSuccess.
 * Use `create(CheckAuthorizationSuccessSchema)` to create a new message.
 */
export const CheckAuthorizationSuccessSchema: GenMessage<CheckAuthorizationSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 21);

/**
 * @generated from message com.gem.bff.contract.UpdateEventParticipantStatusResponse
 */
export type UpdateEventParticipantStatusResponse =
  Message<'com.gem.bff.contract.UpdateEventParticipantStatusResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UpdateEventParticipantStatusResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.UpdateEventParticipantStatusSuccess success = 1;
           */
          value: UpdateEventParticipantStatusSuccess;
          case: 'success';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Unauthorized unauthorized = 2;
           */
          value: CalendarError_Unauthorized;
          case: 'unauthorized';
        }
      | {
          /**
           * @generated from field: com.gem.bff.contract.CalendarError.Forbidden forbidden = 3;
           */
          value: CalendarError_Forbidden;
          case: 'forbidden';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UpdateEventParticipantStatusResponse.
 * Use `create(UpdateEventParticipantStatusResponseSchema)` to create a new message.
 */
export const UpdateEventParticipantStatusResponseSchema: GenMessage<UpdateEventParticipantStatusResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 22);

/**
 * @generated from message com.gem.bff.contract.UpdateEventParticipantStatusSuccess
 */
export type UpdateEventParticipantStatusSuccess =
  Message<'com.gem.bff.contract.UpdateEventParticipantStatusSuccess'> & {
    /**
     * @generated from field: com.gem.bff.contract.CalendarEvent calendarEvent = 1;
     */
    calendarEvent?: CalendarEvent;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateEventParticipantStatusSuccess.
 * Use `create(UpdateEventParticipantStatusSuccessSchema)` to create a new message.
 */
export const UpdateEventParticipantStatusSuccessSchema: GenMessage<UpdateEventParticipantStatusSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 23);

/**
 * @generated from message com.gem.bff.contract.GetUserSettingsResponse
 */
export type GetUserSettingsResponse = Message<'com.gem.bff.contract.GetUserSettingsResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.GetUserSettingsResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetUserSettingsSuccess success = 1;
         */
        value: GetUserSettingsSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.GetUserSettingsResponse.
 * Use `create(GetUserSettingsResponseSchema)` to create a new message.
 */
export const GetUserSettingsResponseSchema: GenMessage<GetUserSettingsResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 24);

/**
 * @generated from message com.gem.bff.contract.GetUserSettingsSuccess
 */
export type GetUserSettingsSuccess = Message<'com.gem.bff.contract.GetUserSettingsSuccess'> & {
  /**
   * @generated from field: bool isCompact = 1;
   */
  isCompact: boolean;

  /**
   * @generated from field: int64 timeFrom = 2;
   */
  timeFrom: bigint;

  /**
   * @generated from field: int64 timeTo = 3;
   */
  timeTo: bigint;
};

/**
 * Describes the message com.gem.bff.contract.GetUserSettingsSuccess.
 * Use `create(GetUserSettingsSuccessSchema)` to create a new message.
 */
export const GetUserSettingsSuccessSchema: GenMessage<GetUserSettingsSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 25);

/**
 * @generated from message com.gem.bff.contract.ChangeCompactResponse
 */
export type ChangeCompactResponse = Message<'com.gem.bff.contract.ChangeCompactResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ChangeCompactResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChangeCompactSuccess success = 1;
         */
        value: ChangeCompactSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ChangeCompactResponse.
 * Use `create(ChangeCompactResponseSchema)` to create a new message.
 */
export const ChangeCompactResponseSchema: GenMessage<ChangeCompactResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 26);

/**
 * @generated from message com.gem.bff.contract.ChangeCompactSuccess
 */
export type ChangeCompactSuccess = Message<'com.gem.bff.contract.ChangeCompactSuccess'> & {
  /**
   * @generated from field: bool isCompact = 1;
   */
  isCompact: boolean;

  /**
   * @generated from field: int64 timeFrom = 2;
   */
  timeFrom: bigint;

  /**
   * @generated from field: int64 timeTo = 3;
   */
  timeTo: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ChangeCompactSuccess.
 * Use `create(ChangeCompactSuccessSchema)` to create a new message.
 */
export const ChangeCompactSuccessSchema: GenMessage<ChangeCompactSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 27);

/**
 * @generated from message com.gem.bff.contract.SearchUsersAddToCalendarEventResponse
 */
export type SearchUsersAddToCalendarEventResponse =
  Message<'com.gem.bff.contract.SearchUsersAddToCalendarEventResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.SearchUsersAddToCalendarEventResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.SearchUsersAddToCalendarEventSuccess success = 1;
           */
          value: SearchUsersAddToCalendarEventSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersAddToCalendarEventResponse.
 * Use `create(SearchUsersAddToCalendarEventResponseSchema)` to create a new message.
 */
export const SearchUsersAddToCalendarEventResponseSchema: GenMessage<SearchUsersAddToCalendarEventResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 28);

/**
 * @generated from message com.gem.bff.contract.SearchUsersAddToCalendarEventSuccess
 */
export type SearchUsersAddToCalendarEventSuccess =
  Message<'com.gem.bff.contract.SearchUsersAddToCalendarEventSuccess'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.PersonalizedUser users = 1;
     */
    users: PersonalizedUser[];

    /**
     * @generated from field: optional string cursor = 2;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.SearchUsersAddToCalendarEventSuccess.
 * Use `create(SearchUsersAddToCalendarEventSuccessSchema)` to create a new message.
 */
export const SearchUsersAddToCalendarEventSuccessSchema: GenMessage<SearchUsersAddToCalendarEventSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 29);

/**
 * @generated from message com.gem.bff.contract.UnsubscribeToCalendarPushResponse
 */
export type UnsubscribeToCalendarPushResponse =
  Message<'com.gem.bff.contract.UnsubscribeToCalendarPushResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.UnsubscribeToCalendarPushResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.UnsubscribeToCalendarPushSuccess success = 1;
           */
          value: UnsubscribeToCalendarPushSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.UnsubscribeToCalendarPushResponse.
 * Use `create(UnsubscribeToCalendarPushResponseSchema)` to create a new message.
 */
export const UnsubscribeToCalendarPushResponseSchema: GenMessage<UnsubscribeToCalendarPushResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 30);

/**
 * @generated from message com.gem.bff.contract.UnsubscribeToCalendarPushSuccess
 */
export type UnsubscribeToCalendarPushSuccess =
  Message<'com.gem.bff.contract.UnsubscribeToCalendarPushSuccess'> & {};

/**
 * Describes the message com.gem.bff.contract.UnsubscribeToCalendarPushSuccess.
 * Use `create(UnsubscribeToCalendarPushSuccessSchema)` to create a new message.
 */
export const UnsubscribeToCalendarPushSuccessSchema: GenMessage<UnsubscribeToCalendarPushSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 31);

/**
 * @generated from message com.gem.bff.contract.GetCalendarAuthUrlResponse
 */
export type GetCalendarAuthUrlResponse =
  Message<'com.gem.bff.contract.GetCalendarAuthUrlResponse'> & {
    /**
     * @generated from oneof com.gem.bff.contract.GetCalendarAuthUrlResponse.type
     */
    type:
      | {
          /**
           * @generated from field: com.gem.bff.contract.GetCalendarAuthUrlSuccess success = 1;
           */
          value: GetCalendarAuthUrlSuccess;
          case: 'success';
        }
      | { case: undefined; value?: undefined };
  };

/**
 * Describes the message com.gem.bff.contract.GetCalendarAuthUrlResponse.
 * Use `create(GetCalendarAuthUrlResponseSchema)` to create a new message.
 */
export const GetCalendarAuthUrlResponseSchema: GenMessage<GetCalendarAuthUrlResponse> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 32);

/**
 * @generated from message com.gem.bff.contract.GetCalendarAuthUrlSuccess
 */
export type GetCalendarAuthUrlSuccess =
  Message<'com.gem.bff.contract.GetCalendarAuthUrlSuccess'> & {
    /**
     * @generated from field: string url = 1;
     */
    url: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetCalendarAuthUrlSuccess.
 * Use `create(GetCalendarAuthUrlSuccessSchema)` to create a new message.
 */
export const GetCalendarAuthUrlSuccessSchema: GenMessage<GetCalendarAuthUrlSuccess> =
  /*@__PURE__*/
  messageDesc(file_calendar_event_response, 33);
